module.exports = __webpack_public_path__ + "modules/bbs/img/35.gif";